import { render, staticRenderFns } from "./BankIdLoginButton.vue?vue&type=template&id=4fa2e48d&scoped=true&"
import script from "./BankIdLoginButton.vue?vue&type=script&lang=js&"
export * from "./BankIdLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2e48d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
